/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
export const TWO_FACTOR_MODAL_ENROLL_FLOWS = Object.freeze({
  SELECT_METHOD: 'SELECT_METHOD',
  SMS: 'SMS',
  AUTH_APP: 'AUTH_APP',
  CODE: 'CODE'
});
export const PHONE_DELIVERY_METHODS = Object.freeze({
  SMS: 'SMS',
  VOICE: 'VOICE'
});

/**
 * Input props
 * @addAuthApp {boolean} - (Optional) used when adding a single AUTH_APP detail
 * @addSms {boolean} - (Optional) used when adding a single SMS detail
 * @initSelectMethodView {boolean} - (Optional) used when showing select method view first is preferred
 * @close {function} - hook function that is called when the enroll modal closes
 * @tPrefix {string} - ember i18n key prefix for all translation keys in two factor enroll components
 * @twoFactorHelpUrl {string} - (Optional) locale based two factor help article path
 * @uppercaseCountry {string} - (Optional) based on locale, used for ember-phone-number input default country selection
 *
 * Usage
 * {{#if this.enrollModalOpen}}
 *    <EmberMultipassComponents::TwoFactor::Modals::Enroll::Base
 *       @addAuthApp={{eq this.methodToEnroll this.methodsToEnroll.AUTH_APP}}
 *       @addSms={{eq this.methodToEnroll this.methodsToEnroll.SMS}}
 *       @close={{this.handleEnrollModalClose}}
 *       @uppercaseCountry={{this.uppercaseCountry}}
 *       @twoFactorHelpUrl={{this.twoFactorHelpUrl}}
 *       @tPrefix={{@tPrefix}}
 *    />
 *  {{/if}}
 */
let TwoFactorModalEnrollComponent = (_dec = service('ember-multipass-logging'), _dec2 = service('ember-multipassfe-client'), _class = class TwoFactorModalEnrollComponent extends Component {
  get disableMethodSelection() {
    return this.args.addSms || this.args.addAuthApp || !this.multipassfeClient.canUseSms;
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "logger", _descriptor, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor2, this);
    _defineProperty(this, "flows", TWO_FACTOR_MODAL_ENROLL_FLOWS);
    _defineProperty(this, "methods", Object.freeze({
      SMS: 'SMS',
      AUTH_APP: 'AUTH_APP'
    }));
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "method", _descriptor3, this);
    _initializerDefineProperty(this, "flow", _descriptor4, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor5, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor6, this);
    _initializerDefineProperty(this, "selectedPhoneDeliveryMethod", _descriptor7, this);
    _initializerDefineProperty(this, "shouldPromptForSecureContactEnrollment", _descriptor8, this);
    this.logger.addComponentBreadcrumb('TwoFactorModalEnrollComponent');
    this.initialTwoFactorEnrollFlow();
  }
  initialTwoFactorEnrollFlow() {
    if (this.args.addSms) {
      this.setFlow(this.flows.SMS);
      this.setMethod(this.methods.SMS);
    } else if (this.args.addAuthApp) {
      this.setFlow(this.flows.AUTH_APP);
      this.setMethod(this.methods.AUTH_APP);
    } else if (this.multipassfeClient.canUseSms) {
      if (this.args.initSelectMethodView) {
        this.setFlow(this.flows.SELECT_METHOD);
      } else {
        this.setFlow(this.flows.SMS);
        this.setMethod(this.methods.SMS);
      }
    } else {
      this.setMethod(this.methods.AUTH_APP);
      this.setFlow(this.flows.AUTH_APP);
    }
  }
  setSelectedPhoneDeliveryMethod(newSelectedPhoneDeliveryMethod) {
    this.selectedPhoneDeliveryMethod = newSelectedPhoneDeliveryMethod;
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setMethod(newMethod) {
    this.method = newMethod;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  setShouldPromptForSecureContactEnrollment(updatedShouldPromptForSecureContactEnrollment) {
    this.shouldPromptForSecureContactEnrollment = updatedShouldPromptForSecureContactEnrollment;
  }
  async resendSmsTwoFactorCodeDebounced() {
    debounce(this, this.resendSmsTwoFactorCode, 500, true);
  }
  async resendSmsTwoFactorCode() {
    try {
      if (this.selectedPhoneDeliveryMethod === this.phoneDeliveryMethods.VOICE) {
        return this.multipassfeClient.enrollTwoFactorVoice(this.phoneNumber);
      }
      return this.multipassfeClient.enrollTwoFactorSms(this.phoneNumber);
    } catch (e) {
      switch (e.message) {
        case 'TEMPORARY_LOCKOUT':
          break;
        default:
          this.logger.sentryError(e);
          this.error = this.intl.t(this.args.tPrefix + 'generic_errors.other.unknown');
      }
    }
  }
  navigateToMethodFlow() {
    if (!this.multipassfeClient.canUseSms) {
      this.setFlow(this.flows.AUTH_APP_ONLY);
    } else if (this.method === this.methods.SMS) {
      this.setFlow(this.flows.SMS);
    } else if (this.method === this.methods.AUTH_APP) {
      this.setFlow(this.flows.AUTH_APP);
    }
  }

  /**
   * Called upon successful enrollment in 2FA
   */
  async finish() {
    await Promise.all([this.multipassfeClient.listTwoFactor(),
    // Fetch new 2FA enrolled details
    this.multipassfeClient.status(),
    // Fetch updated two_factor_provided_timestamp
    this.method === this.methods.SMS ? this.multipassfeClient.listSecureContact() : undefined // Fetch updated SCM details in case 2FA phone was dual-enrolled
    ]);
    // Endpoint /mp/status returns { requires_two_factor } which is an eventually consistent field. Due to the 5 second
    // PersonInfoCache cache invalidation latency it commonly returns false for first ~5 secs after 2FA enrolls.
    this.multipassfeClient.requiresTwoFactor = true;

    // Phone 2FA enrollment completed - prompt for secure contact enrollment using the number if none exist, by passing the phone number back down
    this.args.close({
      dualEnrollSecureContactPhone: this.method === this.methods.SMS && this.shouldPromptForSecureContactEnrollment,
      phoneNumber: this.phoneNumber,
      phoneNumberDisplay: this.phoneNumberDisplay
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "method", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methods.SMS;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.SMS;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedPhoneDeliveryMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.phoneDeliveryMethods.SMS;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "shouldPromptForSecureContactEnrollment", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShouldPromptForSecureContactEnrollment", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShouldPromptForSecureContactEnrollment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToMethodFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToMethodFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "finish", [action], Object.getOwnPropertyDescriptor(_class.prototype, "finish"), _class.prototype), _class);
export { TwoFactorModalEnrollComponent as default };